// src/constants/paymentMethodsConfig.js

const paymentMethods = [
    { key: 'cash', name: 'Cash', icon: 'assets/img/icons/cash-icon.svg', modalId: 'payment-cash',  type: 'modal' },
    { key: 'card', name: 'Card', icon: 'assets/img/icons/card.svg', modalId: 'payment-card',  type: 'modal' },
    { key: 'points', name: 'Points', icon: 'assets/img/icons/points.svg', modalId: 'payment-points' },
    { key: 'deposit', name: 'Deposit', icon: 'assets/img/icons/deposit.svg', modalId: 'payment-deposit' },
    { key: 'cheque', name: 'Cheque', icon: 'assets/img/icons/cheque.svg', modalId: 'payment-cheque' },
    { key: 'gift_card', name: 'Gift Card', icon: 'assets/img/icons/giftcard.svg', modalId: 'gift-payment' },
    { key: 'scan', name: 'Scan', icon: 'assets/img/icons/scan-icon.svg', modalId: 'scan-payment' },
    { key: 'pay_later', name: 'Pay Later', icon: 'assets/img/icons/paylater.svg', modalId: null },
    { key: 'external', name: 'External', icon: 'assets/img/icons/external.svg', modalId: null },
    { key: 'split', name: 'Split Bill', icon: 'assets/img/icons/split-bill.svg', modalId: 'split-payment' },
];

export default paymentMethods;
